import { lighten } from 'polished';
import styled from 'styled-components';
import { aspectRatio as ar } from "../../../../../../common/parameters";

import { HideOnComplete } from "../styles";

export const Drag = styled.div`
    overflow: hidden;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s;
    box-shadow: 0 0 0 3px black inset;
    border-radius: 14px;
    user-select: none;
    &.Christmas {
        background-color: ${p => p.theme.c.christmasBlue};
        box-shadow: 0 0 0 5px ${p => p.theme.c.christmasLightBlue} inset;
        border-radius: 0;
    }

    img {
        background-color: ${p => p.theme.c.white};
        mix-blend-mode: multiply;
    }
    &.Correct {
        background-color: ${p => p.theme.c.correct} !important;
    }

    &.Incorrect {
        background-color: ${p => p.theme.c.incorrect} !important;
    }

    &.Playing {
        background-color: ${p => p.theme.c.check} !important;
    }

    &.Christmas.Playing {
        background-color: ${p => lighten(0.13, p.theme.c.christmasBlue)} !important;
    }

    ${HideOnComplete}
`;

export const PlayBarButton = styled.button`
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 4px 6px;
    opacity: 0.6;
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;

    .i-play {
        color: rgba(0, 0, 0, 0.4);
    }
`;

export const ScorePositioner = styled.div`
    transform-origin: top left;
    user-select: none;
    pointer-events: none;
    width: ${ar.width}px;
    > div {
        overflow: hidden;
    }
`;
